import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/button-grid/button-grid.styles.ts
var button_grid_styles_default = r` .button-grid { display: grid; grid-template-columns: repeat(var(--columns, 3), 1fr); grid-gap: var(--gap, 12px); } `;

export {
  button_grid_styles_default
};
